module.exports = {
  login: 'Login',
  log_in: 'Log In',
  forgot_password: 'Forgot Password?',
  yodlee_id: 'Yodlee ID',
  user_id: 'MyYodlee User ID',
  sub_brand_management: 'Sub-brand Management',
  create_sub_brand: 'Create Sub-brand',
  edit_sub_brand: 'Edit Sub-brand',
  back_to_sub_brands_list: 'Back to Sub-brands List',
  sub_brand: 'Sub-brand',
  sub_brands: 'Sub-brands',
  publish: 'Publish',
  delete: 'Delete',
  setup_header_environment: 'Environment setup',
  setup_header_login: 'Login setup',
  setup_header_products: 'Select products',
  setup_header_contact: 'Contact',
  not_yet_published: 'Not yet published',
  form_sub_head_private: 'Private',
  form_sub_head_public: 'Public',
  form_label_customer_name: 'Customer name',
  form_label_url: 'URL',
  form_label_domain_name: 'Domain name',
  form_label_ip_addresses: 'IP addresses to whitelist for accessing Yodlee APIs (single or range)',
  form_placeholder_ip_addresses: '#.#.#.# or #.#.#.#-#.#.#.#',
  form_label_login_mechanism: 'Login mechanism',
  form_btn_reset_password: 'Reset password',
  form_label_algorithm: 'Algorithm',
  form_label_session_timeout: 'Session timeout',
  form_label_RSA_public_key: 'RSA public key',
  form_label_jwt_issuer_id: 'JWT issuer ID',
  form_link_Add_another_setup: 'Add another setup',
  form_label_login_id_for_yodlee_applications: 'Create Login ID for Yodlee applications',
  form_label_login_id: 'Login ID',
  form_label_SAML_certificate: 'SAML certificate',
  form_btn_upload_cer_file: 'Upload .cer file',
  form_label_SAML_issuer_id: 'SAML issuer ID',
  form_label_SSO_post_source: 'SSO post source',
  form_label_type_of_customer: 'Type of customer',
  form_label_handling_support: 'Who is handling support?',
  form_sub_head_contact: 'Customer contact',
  form_label_login_id_for_contact: 'Create Login ID for Yodlee login',
  form_label_name: 'Name',
  form_label_phone: 'Phone',
  form_label_email: 'Email',
  form_link_Add_another_contact: 'Add another contact',
  form_btn_delete_contact: 'Delete contact',
  form_hint_contact_subbrand_flow: 'Password for Yodlee login will be automatically generated and sent to each contact once the sub-brand is published.',
  form_hint_contact_subbrand_flow1: 'Contacts will receive a link via email to create a Yodlee Customer Care account.',
  form_hint_saml_flow: 'Password for applications will be automatically generated and sent to each contact once the sub-brand is published.',
  form_btn_upload_config_zip: 'Upload Configuration',
  form_btn_reupload_config_zip: 'ReUpload Configuration'
}